import React from "react";
import { Link } from "react-router-dom";
import { CITIES } from "@/data/content";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#111111] text-white mt-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <p className="font-serif-display text-3xl mb-4">
              LexWorkspace
            </p>
            <p className="text-sm text-white/60 max-w-sm leading-relaxed">
              Independent promotional hub for two industry-leading platforms:
              StenoPaceMaster (stenography training) and DraftMaster.ai
              (AI legal drafting). We help professionals find the right tool
              for their craft.
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs tracking-[0.2em] uppercase text-white/40 mb-5">
              Platforms
            </p>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/stenopacemaster" className="hover:text-white/70">
                  Stenography
                </Link>
              </li>
              <li>
                <Link to="/draftmaster" className="hover:text-white/70">
                  Legal AI Drafting
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-white/70">
                  Insights
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.2em] uppercase text-white/40 mb-5">
              Steno by City
            </p>
            <ul className="space-y-3 text-sm">
              {CITIES.map((c) => (
                <li key={"f-s-" + c.slug}>
                  <Link
                    to={`/steno/${c.slug}`}
                    data-testid={`footer-steno-${c.slug}`}
                    className="hover:text-white/70"
                  >
                    Stenography in {c.short}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.2em] uppercase text-white/40 mb-5">
              Legal AI by City
            </p>
            <ul className="space-y-3 text-sm">
              {CITIES.map((c) => (
                <li key={"f-l-" + c.slug}>
                  <Link
                    to={`/legal-ai/${c.slug}`}
                    data-testid={`footer-legal-${c.slug}`}
                    className="hover:text-white/70"
                  >
                    Legal AI in {c.short}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
          <p>
            © {new Date().getFullYear()} LexWorkspace. Independent promotional
            site. Not affiliated with any government agency.
          </p>
          <div className="flex gap-6">
            <a
              href="https://stenopacemaster.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              stenopacemaster.com
            </a>
            <a
              href="https://draftmaster.ai"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              draftmaster.ai
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
